import { createFileRoute } from "@tanstack/react-router"
import { OverviewPage } from "~/components/design-system/pages"
import { SeasonalityPlanningTab } from "~/components/budget/planning/PlanningTabs"

export const Route = createFileRoute(
  "/_auth/budgets/_layout/$fiscalYear/$budgetId/_layout/allocation-planning",
)({
  component: RouteComponent,
})

function RouteComponent() {
  // Plain OverviewPage (no fillContent) scrolls, so the per-period grid isn't clipped.
  return (
    <OverviewPage>
      <SeasonalityPlanningTab />
    </OverviewPage>
  )
}
